import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Table, Button, Tooltip, Modal,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../util/react';
import { msgCB } from '../../../util/fetch/msgFetch';
import { actUI } from '../../../redux/action/ui';
import { PAGE_SIZE } from '../../../config';

const delIcon = require('../../../static/image/delete-normal.png');
const warningIcon = require('../../../static/image/warningIcon.png');

export class NewTable extends Component {
  handleChange = (page) => {
    const { onChange, dispatch } = this.props;
    const offset = (page.current - 1) * PAGE_SIZE;
    actUI(dispatch, { uiAccount: { offset } });
    onChange({ limit: PAGE_SIZE, offset });
  }

  handleDelete = (accountName) => {
    const { intl, onDelete, dispatch } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, { uiAccount: { uiTable: { loading: false } } });
      switch (res.status) {
        default:
          return msgCB(res.status, formatMessage);
      }
    };
    actUI(dispatch, { uiAccount: { uiTable: { loading: true } } });
    onDelete(
      {
        Name: accountName,
      },
      cb,
    );
  }

  translateData = () => {
    const { data } = this.props;
    const d = JSON.parse(JSON.stringify(data.results));
    return d;
  }

  render() {
    const {
      intl, filePath, className, data, ui, offset, onEdit,
    } = this.props;
    const { formatMessage } = intl;
    const columns = [
      {
        title: (
          <FormattedMessage
            id="Account.associatedDevice"
            defaultMessage="device"
          />
        ),
        dataIndex: 'AssociatedDevice',
        key: 'AssociatedDevice',
        width: 130,
        render: (text, record) => (
          <Button onClick={() => onEdit(record.id)} className="a-click">
            {text}
          </Button>
        ),
      },
      {
        title: (
          <FormattedMessage
            id="Account.displayName"
            defaultMessage="display name"
          />
        ),
        dataIndex: 'DisplayName',
        key: 'DisplayName',
        width: 210,
      },
      {
        title: (
          <FormattedMessage
            id="Account.accountName"
            defaultMessage="account name"
          />
        ),
        dataIndex: 'AccountName',
        key: 'AccountName',
        width: 170,
      },
      {
        title: (
          <FormattedMessage
            id="Account.accountPassword"
            defaultMessage="account password"
          />
        ),
        dataIndex: 'Password',
        key: 'Password',
        width: 120,
      },
      {
        title: (
          <FormattedMessage id="Account.bindDevice" defaultMessage="Device" />
        ),
        dataIndex: 'Device_Type',
        key: 'Device_Type',
        width: 150,
      },
      {
        title: (
          <FormattedMessage id="app.table.action" defaultMessage="action" />
        ),
        key: 'action',
        render: (text, record) => (
          <span>
            <Tooltip
              placement="topLeft"
              title={formatMessage({
                id: 'app.btn.delete',
                defaultMessage: 'delete',
              })}
            >
              <Button
                type="primary"
                size="small"
                className="action-button"
                onClick={Modal.confirm.bind(this, {
                  class: 'del-modal-confirm',
                  title: formatMessage({
                    id: 'app.warn.confirmDelete',
                    defaultMessage: 'are you sure to delete the release?',
                  }),
                  content: formatMessage({
                    id: 'app.warn.operationIrrevocable',
                    defaultMessage: 'this operation is irrevocable',
                  }),
                  okText: formatMessage({
                    id: 'app.btn.ok',
                    defaultMessage: 'ok',
                  }),
                  cancelText: formatMessage({
                    id: 'app.btn.cancel',
                    defaultMessage: 'cancel',
                  }),
                  onOk: this.handleDelete.bind(this, record.AccountName),
                  icon: <img src={warningIcon} alt="" />,
                })}
                // icon="minus"
              >
                <img src={delIcon} alt="" style={{ height: '32px', width: '32px' }} />
              </Button>
            </Tooltip>
          </span>
        ),
        width: 60,
      },
    ];
    return (
      <Table
        className={`${filePath} ${className}`}
        columns={columns}
        rowKey="id"
        dataSource={this.translateData()}
        locale={{
          emptyText: (
            <FormattedMessage id="app.data.empty" defaultMessage="no data" />
          ),
        }}
        pagination={{
          current: offset / PAGE_SIZE + 1,
          pageSize: PAGE_SIZE,
          total: data.count,
        }}
        loading={ui.loading}
        onChange={this.handleChange}
      />
    );
  }
}

NewTable.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        DisplayName: PropTypes.string.isRequired,
        AssociatedDevice: PropTypes.string.isRequired,
        AccountName: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  offset: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default wrapReact(NewTable, 'container_account_Table');
